import { Component, OnInit } from '@angular/core';
import { ModalController, IonInfiniteScroll, Platform } from '@ionic/angular';
import { PotentialMemberslistPage } from '../potential-memberslist/potential-memberslist.page'
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpCustomerService, MessageclientService, NativeService } from 'src/service';
import { WebParameterContext } from 'src/model/common';
import { GridBaseCase } from '../../grid/grid.base.case';
import { BaseCase } from 'src/app/basecase';
import { BaseModal } from 'src/model';
declare var app;
@Component({
  selector: 'app-potential-members-list',
  templateUrl: './potential-members-list.component.html',
  styleUrls: ['./potential-members-list.component.scss']
})
export class PotentialMembersListComponent extends GridBaseCase {
  tabstranIndex: number = 1;
  productShow: boolean = false;
  enableBackdropDismiss = true;
  showBackdrop = true;
  shouldPropagate = true;
  lineradirs: boolean = false; // 圆点是否显示
  PageNumber: number = 1;
  tab1PageNumber: number = 1;//潜在会员
  tab2PageNumber: number = 1;//其他潜在会员
  tab3PageNumber: number = 1;
  tab4PageNumber: number = 1;
  dataArrayList1: Array<any> = [];//潜在会员
  dataArrayList2: Array<any> = [];//其他潜在会员
  dataArrayList3: Array<any> = [];//s1-2级会员
  dataArrayList4: Array<any> = [];//其他阶段会员

  oldRecordCount1Number: number = 1;//潜在会员
  oldRecordCount2Number: number = 1;//其他潜在会员
  oldRecordCount3Number: number = 1;
  oldRecordCount4Number: number = 1;

  RecordCount1Number: number = 1;//潜在会员
  RecordCount2Number: number = 1;//其他潜在会员
  RecordCount3Number: number = 1;
  RecordCount4Number: number = 1;
  CustomerStatusObj: any = {};
  pageCount: number = 10;
  potentialNember :boolean=true; //潜在会员
  stockNembers:boolean=true; // 存量会员
  IsRead:any;  // 列表里边是否显示红点
  recordWechatID:any=""; //  记录返回的额id
  dataListNone:boolean=false;
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    private native: NativeService,
    public baseService: BaseCase,
    public base: BaseModal,
    public modal: ModalController
  ) {
    super();
  }

  ngOnInit() {
    this.LoadCustomerStatus(1);
    this.LoadData1(1);
  }
  // 切换
  tabstranEvent(num) {
    const that = this;
    that.tabstranIndex = num;
  }
  arrowSee() {
    const that = this;
    that.productShow = !that.productShow;
  }


 
  /**
   * 已申请试用/有关注得标签
   * @param PageNumber 
   */
  LoadData1(PageNumber) {
    var that = this;
    that.tab1PageNumber = PageNumber;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;

    body.ConfigName = "GetMemberCareList";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    if (PageNumber > 1) {
      body.RowsPerPage = 1000;
    }
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let typeObj = {};
    //ExamineState  1 审批通过  2 审批拒绝  3 待审批   4 无需审批
    // typeObj["Status"] = 1;
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {

      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.baseService.arrayData = [];
        // that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {

      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        that.baseService.arrayData = data.Status;
          if(data.Status !== null || data.Status !== "null"){
        // debugger;
        that.dataArrayList1 = data.Status["shiyong"]["shiyongmembers"] || [];
        that.dataArrayList1.forEach(item=>{
          item.tempName="";
          if(item["CRM_Name"]){
            item.tempName=item["CRM_Name"];
          }else{
            item.tempName=item["TA_Name"];
          }

        });
        
        that.dataArrayList2 = data.Status["meishiyong"]["meishiyongmembers"] || [];
        that.dataArrayList2.forEach(item=>{
          item.tempName="";
          if(item["CRM_Name"]){
            item.tempName=item["CRM_Name"];
          }else{
            item.tempName=item["TA_Name"];
          }

        });
        that.dataArrayList3 = data.Status["s1s2"]["s1s2members"] || [];
        that.dataArrayList3.forEach(item=>{
          item.tempName="";
          if(item["CRM_Name"]){
            item.tempName=item["CRM_Name"];
          }else{
            item.tempName=item["TA_Name"];
          }

        });
        that.dataArrayList4 = data.Status["s3"]["s3members"] || [];
        that.dataArrayList4.forEach(item=>{
          item.tempName="";
          if(item["CRM_Name"]){
            item.tempName=item["CRM_Name"];
          }else{
            item.tempName=item["TA_Name"];
          }

        });
        that.potentialNember = data.Status.qianzai; // 潜在会员是否显示红点
        that.stockNembers = data.Status.cunliang; //存量会员是否显示红点

        that.RecordCount1Number = that.dataArrayList1.length;
        that.RecordCount2Number = that.dataArrayList2.length;
        that.RecordCount3Number = that.dataArrayList3.length;
        that.RecordCount4Number = that.dataArrayList4.length;

        that.oldRecordCount1Number = that.dataArrayList1.length;
        that.oldRecordCount2Number = that.dataArrayList2.length;
        that.oldRecordCount3Number = that.dataArrayList3.length;
        that.oldRecordCount4Number = that.dataArrayList4.length;

        that.dataArrayList1 = that.dataArrayList1.slice(0, 3);
        that.dataArrayList2 = that.dataArrayList2.slice(0, 3);
        that.dataArrayList3 = that.dataArrayList3.slice(0, 3);
        that.dataArrayList4 = that.dataArrayList4.slice(0, 3);
        console.log(that.dataArrayList1, "dataArrayList");
        /****上拉加载数据begin****/
        // that.RecordCount1Number = data.Status.RecordCount/app.RowsPerPage;
        // if (that.RecordCount1Number == data.Status.Datas.length || that.RecordCount1Number == that.baseService.arrayData.length) {
        // } else {
        // }
        /****上拉加载数据end****/
      }
    }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      // console.log(error);
    });
  }

  /** 查看全部
   * listType
   *  潜在会员
      其他潜在会员
      s1-2级会员
      其他阶段会员
   * @param listType    
      分页页数
   * @param PageNumber
   */
  MoreLoadData(listType, PageNumber) {
    var that = this;

    let data = that.baseService.arrayData;
    if (listType == 1) {
      that.dataArrayList1 = data["shiyong"]["shiyongmembers"] || [];
      that.tab1PageNumber++;  
      // that.RecordCount1Number = 3 + that.tab1PageNumber * 10;
      // that.dataArrayList1 = that.dataArrayList1.slice(0, that.RecordCount1Number);
      that.dataArrayList1 = that.dataArrayList1 || [];
      that.dataArrayList1.forEach(item=>{
        item.tempName="";
        if(item["CRM_Name"]){
          item.tempName=item["CRM_Name"];
        }else{
          item.tempName=item["TA_Name"];
        }

      });

    } else if (listType == 2) {
      that.dataArrayList2 = data["meishiyong"]["meishiyongmembers"] || [];
      that.tab2PageNumber++;
      // that.RecordCount2Number = 3 + that.tab2PageNumber * 10;
      // that.dataArrayList2 = that.dataArrayList2.slice(0, that.RecordCount2Number);
      that.dataArrayList2 = that.dataArrayList2 || [];
      that.dataArrayList2.forEach(item=>{
        item.tempName="";
        if(item["CRM_Name"]){
          item.tempName=item["CRM_Name"];
        }else{
          item.tempName=item["TA_Name"];
        }

      });

    }
    else if (listType == 3) {
      that.dataArrayList3 = data["s1s2"]["s1s2members"] || [];
      that.tab3PageNumber++;
      // that.RecordCount3Number = 3 + that.tab3PageNumber * 10;
      console.log( that.dataArrayList3);
      console.log(that.RecordCount3Number)
      // that.dataArrayList3 = that.dataArrayList3.slice(0, that.RecordCount3Number);
      that.dataArrayList3 = that.dataArrayList3 || [];
      that.dataArrayList3.forEach(item=>{
        item.tempName="";
        if(item["CRM_Name"]){
          item.tempName=item["CRM_Name"];
        }else{
          item.tempName=item["TA_Name"];
        }

      });
    }
    else if (listType == 4) {
      that.tab4PageNumber++;
      that.dataArrayList4 = data["s3"]["s3members"] || [];
      // that.RecordCount4Number = 3 + that.tab4PageNumber * 10;
      // that.dataArrayList4 = that.dataArrayList4.slice(0, that.RecordCount4Number);
      that.dataArrayList4 = that.dataArrayList4 || [];
      that.dataArrayList4.forEach(item=>{
        item.tempName="";
        if(item["CRM_Name"]){
          item.tempName=item["CRM_Name"];
        }else{
          item.tempName=item["TA_Name"];
        }

      });
    }
    console.log(that.dataArrayList3, "dataArrayList3");
  }
  MoreLoadDataList(listType){
    console.log(listType,"nfrnnnnnnnnnnnnnnn")
    var that = this;
    let data = that.baseService.arrayData;
    if (listType == 1) {
      that.dataArrayList1 = data["shiyong"]["shiyongmembers"] || [];
      that.tab1PageNumber=3;
       that.RecordCount1Number = 3;
       that.dataArrayList1 = that.dataArrayList1.slice(0, that.RecordCount1Number);
      that.dataArrayList1.forEach(item=>{
        item.tempName="";
        if(item["CRM_Name"]){
          item.tempName=item["CRM_Name"];
        }else{
          item.tempName=item["TA_Name"];
        }

      });

    } else if (listType == 2) {
      that.dataArrayList2 = data["meishiyong"]["meishiyongmembers"] || [];
      that.tab2PageNumber=3;
      that.RecordCount2Number = 3;
      that.dataArrayList2 = that.dataArrayList2.slice(0, that.RecordCount2Number);
      that.dataArrayList2.forEach(item=>{
        item.tempName="";
        if(item["CRM_Name"]){
          item.tempName=item["CRM_Name"];
        }else{
          item.tempName=item["TA_Name"];
        }

      });

    }
    else if (listType == 3) {
      that.dataArrayList3 = data["s1s2"]["s1s2members"] || [];
      that.tab3PageNumber=3;
      that.RecordCount3Number = 3;
      that.dataArrayList3 = that.dataArrayList3.slice(0, that.RecordCount3Number);
       
      that.dataArrayList3.forEach(item=>{
        item.tempName="";
        if(item["CRM_Name"]){
          item.tempName=item["CRM_Name"];
        }else{
          item.tempName=item["TA_Name"];
        }

      });
      console.log(that.dataArrayList3,"jjjjjjjjjjjj")
    }
    else if (listType == 4) {
      that.tab4PageNumber=3;
      that.dataArrayList4 = data["s3"]["s3members"] || [];
      that.RecordCount4Number = 3;
      that.dataArrayList4 = that.dataArrayList4.slice(0, that.RecordCount4Number);
      that.dataArrayList4.forEach(item=>{
        item.tempName="";
        if(item["CRM_Name"]){
          item.tempName=item["CRM_Name"];
        }else{
          item.tempName=item["TA_Name"];
        }

      });
    }
  }
  /**
   * 
   * 会员状态
   */
  LoadCustomerStatus(PageNumber) {
    var that = this;
    that.tab1PageNumber = PageNumber;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;

    body.ConfigName = "GetTBMemberCareIsReadBySnc";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    if (PageNumber > 1) {
      body.RowsPerPage = 1000;
    }
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let typeObj = {};
    //ExamineState  1 审批通过  2 审批拒绝  3 待审批   4 无需审批
    typeObj["Status"] = 2;
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        if (data.Status) {
          that.CustomerStatusObj = data.Status || {};
        }
      }
    }).catch(error => {
      // that.msg.Alert(app.ErrorMessage);
      console.log(error);
    });
  }

  //  点击二次沟通按钮弹窗
  async SecondCommunication(type,item,number) {
    console.log("点击弹窗")
    const that = this;
    const modal = await that.modal.create({
      component: PotentialMemberslistPage,
      componentProps: {
      }
    });
    await modal.present();
    // return await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data, "onWillDismiss");
    let leixing:any=data.type;
    if(data&&data.modalStatus)
    {
     
      const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
  
      body.ConfigName = "Update_MOT_StatusBySNC";
      body.OpType = "edite";
      body.ConfigType = "form";
      body.RowsPerPage = app.RowsPerPage;
     
      body.PageNumber = 1;
      body.Client.PageName = PageName;
      body.Client.ApiType = "Element";
      body.Client.Name = "";
      body.Client.ClientType = 2;
      if (that.platform.is("android")) {
        body.Client.ClientType = 0;
      } else if (that.platform.is("ios")) {
        body.Client.ClientType = 1;
      }
      let typeObj = {};
      //ExamineState  1 审批通过  2 审批拒绝  3 待审批   4 无需审批
      typeObj["ID"] =item.ID||"";
      typeObj["Status"] = data.type||0;
      body.RequestBody = JSON.stringify(typeObj);
      that.http.post(app.DEFAULTURL, body).then(data => {
  
        /****判断是否第一页end****/
        if (data.ResponseMessage.Success) {
         that.msg.Alert("操作成功").then(res=>{
          if(leixing){
            switch(type){
              case "A":
                that.dataArrayList1.splice(number,1);
                break;
                case "B":
                  that.dataArrayList2.splice(number,1);
                break;
                case "C":
                  that.dataArrayList3.splice(number,1);
                break;
                case "D":
                  that.dataArrayList4.splice(number,1);
                break;
            }
          }

         });
          console.log(that.dataArrayList2, "操作成功");

        }
  
      }).catch(error => {
       
        // console.log(error);
      });
    }
  }
  /**
 * 记录发微信的接口
 */
 recordWechat(item){
  const that =this;
  const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  let body = new WebParameterContext();
  body.Account = that.com.GetAccount;
  body.ConfigName = "TBSendMessageRecordXML";
  body.OpType = "add";
  body.ConfigType = "form";
  body.RowsPerPage = 15;
  body.PageNumber = 1;
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.Name = "product";
  body.Client.ClientType = 2;
  if (that.platform.is("android")) {
    body.Client.ClientType = 0;
  } else if (that.platform.is("ios")) {
    body.Client.ClientType = 1;
  }
  let typeObj = {};
  typeObj["a_MembersOpenID"] =  item.openid;
  typeObj["a_MembersUnionid"] = item.UnionId;
  typeObj["a_MembersTelPhone"] = item.TA_Mobile;
  // typeObj["motid"] = "91FFCD56-D91C-4977-BC2A-91C73E49B90A";
  body.RequestBody = JSON.stringify(typeObj);
 that.msg.Loading("加载中，请稍后...").then(load=>{
  that.http.post(app.DEFAULTURL, body).then(data => {
    load.dismiss();
    if (data.ResponseMessage.Success) {
      console.log(data.Status,"uuuuuuuuuuuu")
        if(data.Status){
          that.recordWechatID = data.Status
        }
      
    }else{
      that.msg.Alert(data.ResponseMessage.ErrorMessage);
    }

  }).catch(error => {
    load.dismiss();
    that.msg.Alert(error.ResponseMessage.ErrorMessage);
    // console.log(error);
  });
   load.present();
 })         
 }
  // 点击列表跳转详情页
  EventDetail(item, i,type) {
    const that = this;
    // let _obj = {};
    // _obj["ID"] = item.ID || "";
    // _obj["IsRead"] = item.IsRead || false;
    // debugger;
    if(item.MOT_DEF_No == 215 || item.MOT_DEF_No == "215" || item.MOT_DEF_No == 216 || item.MOT_DEF_No == "216" || item.MOT_DEF_No == "217" ||  item.MOT_DEF_No == 217){
      const that =this;
      const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
      body.ConfigName = "TBSendMessageRecordXML";
      body.OpType = "add";
      body.ConfigType = "form";
      body.RowsPerPage = 15;
      body.PageNumber = 1;
      body.Client.PageName = PageName;
      body.Client.ApiType = "Element";
      body.Client.Name = "product";
      body.Client.ClientType = 2;
      if (that.platform.is("android")) {
        body.Client.ClientType = 0;
      } else if (that.platform.is("ios")) {
        body.Client.ClientType = 1;
      }
      let typeObj = {};
      typeObj["a_MembersOpenID"] =  item.openid;
      typeObj["a_MembersUnionid"] = item.UnionId;
      typeObj["a_MembersTelPhone"] = item.TA_Mobile;
      // typeObj["motid"] = "91FFCD56-D91C-4977-BC2A-91C73E49B90A";
      body.RequestBody = JSON.stringify(typeObj);
     that.msg.Loading("加载中，请稍后...").then(load=>{
      that.http.post(app.DEFAULTURL, body).then(data => {
        load.dismiss();
        if (data.ResponseMessage.Success) {
          console.log(data.Status,"uuuuuuuuuuuu")
            if(data.Status){
              that.recordWechatID = data.Status;
               item.recordWechatID= that.recordWechatID;
              console.log(item,"jjjjjjjjjjjj")
              if(type){
                if(type=="A"){
                  let isred:boolean=false;
                  let isred2:boolean=false;
                 if(!that.dataArrayList1.find(item=>item.IsRead==false)){
                  isred=true;
                 }
                 if(!that.dataArrayList2.find(item=>item.IsRead==false)){
                  isred2=true;
                 }
                 if(isred && isred2){
                   that.potentialNember=true;
                 }
                }else if(type=="B"){
                  let isredB:boolean=false;
                  let isredB2:boolean=false;
                 if(!that.dataArrayList1.find(item=>item.IsRead==false)){
                  isredB=true;
                 }
                 if(!that.dataArrayList2.find(item=>item.IsRead==false)){
                  isredB2=true;
                 }
                 if(isredB && isredB2){
                   that.stockNembers=true;
                 }
                }
              }
              if(!item.IsRead){
                that.UpdateStatus(item.ID);
              }
              item.IsRead=true;
              console.log(item,"jjjjjjjjjjjj")
          
              // item.Stage =6;
              that.com.setHistoryUrl(true);
              that.com.Go("/tabs/contact/PotentialMembersDetail/" + that.com.getNowDatetime,item);


            }
          
        }else{
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
    
      }).catch(error => {
        load.dismiss();
        that.msg.Alert(error.ResponseMessage.ErrorMessage);
        // console.log(error);
      });
       load.present();
     })
    }else{
      if(type){
        if(type=="A"){
          let isred:boolean=false;
          let isred2:boolean=false;
         if(!that.dataArrayList1.find(item=>item.IsRead==false)){
          isred=true;
         }
         if(!that.dataArrayList2.find(item=>item.IsRead==false)){
          isred2=true;
         }
         if(isred && isred2){
           that.potentialNember=true;
         }
        }else if(type=="B"){
          let isredB:boolean=false;
          let isredB2:boolean=false;
         if(!that.dataArrayList1.find(item=>item.IsRead==false)){
          isredB=true;
         }
         if(!that.dataArrayList2.find(item=>item.IsRead==false)){
          isredB2=true;
         }
         if(isredB && isredB2){
           that.stockNembers=true;
         }
        }
      }
     
      
      if(!item.IsRead){
        that.UpdateStatus(item.ID);
      }
      item.IsRead=true;
     
     
      // item.s2Count=1;
      
      console.log(item,"jjjjjjjjjjjj")
  
      // item.Stage =6;
      that.com.setHistoryUrl(true);
      that.com.Go("/tabs/contact/PotentialMembersDetail/" + that.com.getNowDatetime,item);
    }
   
    // that.router.navigate(["/tabs/contact/PotentialMembersDetail/" + that.com.getNowDatetime], {
    //   queryParams: item
    // });
  
  }
  /**
 * 修改会员已读
 */
UpdateStatus(id:any){
  const that = this;
  const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  let body = new WebParameterContext();
  body.Account = that.com.GetAccount;

  body.ConfigName = "TBMemberCareXML";
  body.OpType = "edite";
  body.ConfigType = "form";
  body.RowsPerPage = app.RowsPerPage;
 
  body.PageNumber = 1;
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.Name = "";
  body.Client.ClientType = 2;
  if (that.platform.is("android")) {
    body.Client.ClientType = 0;
  } else if (that.platform.is("ios")) {
    body.Client.ClientType = 1;
  }
  let typeObj = {};
  //ExamineState  1 审批通过  2 审批拒绝  3 待审批   4 无需审批
  typeObj["a_ID"] = id;
  typeObj["a_IsRead"] =  true;
  body.RequestBody = JSON.stringify(typeObj);
  that.http.post(app.DEFAULTURL, body).then(data => {
    /****判断是否第一页end****/
    if (data.ResponseMessage.Success) {
    //  that.msg.Alert("操作成功");
      console.log(that.dataArrayList2, "操作成功");
    }
  }).catch(error => {
    // console.log(error);
  });
}
}
